import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useBreakpoint } from "gatsby-plugin-breakpoints";

import Button from "../Button";
import Icon from "../Icon";

import * as navigationStyles from "./Navigation.module.css";

const Navigation = (props) => {
  const { lightLogo, darkLogo, pages, callToAction } = props.navigation;

  const { email, phone, socialLinks } = props.company;

  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [dropDown, setDropDown] = useState(null);
  const [showDesktopStickyNav, setShowDesktopStickyNav] = useState(false);

  const dropDownRef = useRef(null);

  const setDropDownRef = (value) => {
    dropDownRef.current = value;
    setDropDown(value);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (dropDownRef.current) {
        setDropDownRef(null);
        setDropDownOpen(false);
      }

      const currentScrollPos = window.scrollY;
      setShowDesktopStickyNav(currentScrollPos >= 500);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleDropDown = (newDropDown, currentDropDown) => {
    setDropDownRef(newDropDown);
    setDropDownOpen(newDropDown === currentDropDown ? !dropDownOpen : true);
  };

  const closeDropDown = () => {
    setDropDownRef(null);
    setDropDownOpen(false);
  };

  const SocialLink = ({ social }) => {
    return (
      <a
        className={navigationStyles.iconWrapper}
        href={social.link}
        target="_blank"
        rel="noreferrer"
      >
        <Icon
          props={{
            size: "xl",
            isBrand: true,
            name: social.icon.name,
          }}
        />
      </a>
    );
  };

  const breakpoints = useBreakpoint();

  return (
    <header>
      <div className={`${navigationStyles.navigation}`}>
        <div
          className={`${navigationStyles.mainSection} ${
            props.enableDarkNav ? navigationStyles.darkNav : null
          }`}
        >
          <div>
            <div
              // data-aos={breakpoints.md ? null : "fade-in"}
              // data-aos-duration={breakpoints.md ? null : "300"}
              className={navigationStyles.logoContainer}
            >
              <Link to="/">
                <GatsbyImage
                  image={getImage(
                    dropDownOpen
                      ? lightLogo.file.gatsbyImageData
                      : props.enableDarkNav
                      ? darkLogo.file.gatsbyImageData
                      : lightLogo.file.gatsbyImageData
                  )}
                  alt={props.enableDarkNav ? darkLogo.alt : lightLogo.alt}
                  className={navigationStyles.logo}
                  loading="eager"
                />
              </Link>
            </div>
            <nav
            // data-aos={breakpoints.md ? null : "fade-in"}
            // data-aos-duration={breakpoints.md ? null : "700"}
            >
              <ul>
                {pages.map((page, index) => (
                  <li
                    key={`${page.id}-${index}`}
                    className={`${navigationStyles.desktopLink} ${
                      dropDownOpen && navigationStyles.dropDownOpen
                    }`}
                  >
                    {page.navSubPages && page.navSubPages.length ? (
                      <button
                        onClick={() =>
                          toggleDropDown(page.navLabel, dropDownRef.current)
                        }
                        onKeyDown={() =>
                          toggleDropDown(page.navLabel, dropDownRef.current)
                        }
                        className={
                          dropDownRef && dropDownRef === page.navLabel
                            ? "active"
                            : null
                        }
                      >
                        {page.navLabel}
                        {/* <Icon
                          props={{
                            name:
                              dropDown && dropDown === page.navLabel
                                ? "fa-chevron-up"
                                : "fa-chevron-down",
                            type: "solid",
                            // size: "xl",
                            color: "secondary",
                          }}
                        /> */}
                      </button>
                    ) : (
                      <Link
                        to={page.slug}
                        onClick={closeDropDown}
                        onKeyDown={closeDropDown}
                      >
                        {page.navLabel}
                      </Link>
                    )}
                    {dropDownOpen &&
                      dropDownRef.current === page.navLabel &&
                      dropDown === page.navLabel &&
                      page.navSubPages.length && (
                        <div className={navigationStyles.dropDown}>
                          <div>
                            <div>
                              <ul>
                                {page.navSubPages.map((page, index) => {
                                  // const aosDuration =
                                  // index === 0 ? 300 : 300 + index * 250;
                                  return (
                                    <li
                                      // data-aos="fade-in"
                                      // data-aos-duration={aosDuration}
                                      key={`${page.id}-${index}`}
                                    >
                                      <Link to={page.slug}>
                                        {page.navLabel}
                                      </Link>
                                    </li>
                                  );
                                })}
                                {/* <li
                                  data-aos="fade-right"
                                  data-aos-duration={
                                    300 + page.navSubPages.length + 1 * 250
                                  }
                                >
                                  <Link to={page.slug}>
                                    View {page.navLabel}
                                  </Link>
                                </li> */}
                              </ul>
                            </div>

                            <div
                            // data-aos="fade-in"
                            // data-aos-duration="2000"
                            >
                              <h5>{page.pageTitle}</h5>

                              {page.shareImage.gatsbyImageData && (
                                <GatsbyImage
                                  image={getImage(
                                    page.shareImage.gatsbyImageData
                                  )}
                                  alt={page.pageTitle}
                                />
                              )}
                              <p>{page.pageDescription}</p>
                              <Link to={page.slug}>View {page.navLabel}</Link>
                            </div>
                          </div>
                        </div>
                      )}
                  </li>
                ))}
                <li className={navigationStyles.callToAction}>
                  <Button
                    styleAsButton
                    variant="darkBlue"
                    destination={callToAction.slug}
                  >
                    {callToAction.navLabel}
                  </Button>
                </li>
                <li className={navigationStyles.mobileNavTrigger}>
                  <button
                    aria-label="open navigation"
                    onClick={() => setMobileNavOpen(true)}
                  >
                    <Icon
                      props={{
                        name: "fa-bars",
                        type: "solid",
                        size: "xl",
                        color: "secondary",
                      }}
                    />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      {dropDownOpen && (
        <div
          tabIndex="0"
          role="button"
          aria-label="transparent back drop"
          onClick={() => toggleDropDown(dropDownRef.value, dropDownRef.value)}
          onKeyDown={() => toggleDropDown(dropDownRef.value, dropDownRef.value)}
          className={navigationStyles.veilOfDarkness}
        ></div>
      )}
      {showDesktopStickyNav && (
        <div className={navigationStyles.desktopStickyNav}>
          <div>
            <div
              // data-aos="fade-in"
              // data-aos-duration="300"
              className={navigationStyles.imgContainer}
            >
              <Link to="/">
                <GatsbyImage
                  image={getImage(darkLogo.file.gatsbyImageData)}
                  alt={props.enableDarkNav ? darkLogo.alt : lightLogo.alt}
                  className={navigationStyles.logo}
                />
              </Link>
            </div>
          </div>
          <div>
            {window.location.pathname.includes("/services/") ? (
              <Button styleAsButton variant="seaGreen" destination="#leadForm">
                Discuss My Project
              </Button>
            ) : null}
            {window.location.pathname.includes("/industries/") ? (
              <Button
                styleAsButton
                variant="darkBlue"
                destination="/free-consultation/"
              >
                Free Consultation
              </Button>
            ) : null}
            <Button
              styleAsButton
              variant="brightBlue"
              destination={callToAction.slug}
            >
              {callToAction.navLabel}
            </Button>
            <Link
              className={navigationStyles.backToTop}
              aria-label="to top"
              to="#main"
            >
              <Icon
                props={{
                  name: "fa-arrow-up",
                  type: "solid",
                  size: "xl",
                  color: "white",
                }}
              />
            </Link>
          </div>
        </div>
      )}
      {mobileNavOpen && (
        <div className={navigationStyles.mobileNav}>
          <div
          // data-aos="fade-down"
          // data-aos-duration="300"
          >
            <div className={navigationStyles.logoContainer}>
              <Link to="/">
                <GatsbyImage
                  image={getImage(lightLogo.file.gatsbyImageData)}
                  alt={darkLogo.alt}
                  className={navigationStyles.logo}
                />
              </Link>
            </div>
            <button
              aria-label="close navigation"
              onClick={() => setMobileNavOpen(false)}
            >
              <Icon
                props={{
                  name: "fa-times",
                  type: "solid",
                  size: "lg",
                  color: "white",
                }}
              />
              close
            </button>
          </div>
          <div className={navigationStyles.majorLinks}>
            <nav>
              <ul>
                {pages.map((page, index) => {
                  // const mobileAosDuration =
                  // index === 0 ? 300 : 300 + index * 250;
                  return (
                    <li
                    // data-aos="fade-right"
                    // data-aos-duration={mobileAosDuration}
                    >
                      <Link to={page.slug}>
                        <>
                          {page.navLabel}
                          <FontAwesomeIcon icon={faChevronRight} />
                        </>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </div>
          <div
            // data-aos="fade-down"
            // data-aos-duration="900"
            className={navigationStyles.contact}
          >
            <div className={navigationStyles.details}>
              <p>
                <a href={`mailto:${email}`}>{email}</a>
              </p>
              <p>
                <a href={`tel:${phone}`}>{phone}</a>
              </p>
              <p
                dangerouslySetInnerHTML={{
                  __html: props.company.address.childMarkdownRemark.html,
                }}
              />
            </div>
            <div className={navigationStyles.socialLinks}>
              {socialLinks.map((social) => {
                return <SocialLink social={social} key={social.name} />;
              })}
            </div>
            <div>
              <Link
                className={navigationStyles.mobileCallToAction}
                to={callToAction.slug}
              >
                {callToAction.navLabel}
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navigation;
